import { ContextService } from '@services/context.service';

export interface IContextCore {
  brand: string;
  channel: string;
  company: string;
  site: string;
  language: string;
  locale: string;
  currency: {
    code: string;
    description: string;
  };
  isBot: boolean;
  isLanding: boolean;
  seo: {};
  disableARS: boolean;
}
export interface IContextDevice {
  userAgent: string;
  os: string;
  browser: string;
  device: string;
  type: string;
  os_version: string;
  browser_version: string;
  isMobile: boolean;
  isDesktop: boolean;
  isTablet: boolean;
}
export interface IContextState {
  core: IContextCore;
  device: IContextDevice;
}

export const initialState: IContextState = new ContextService().getInitialState();
